export enum PERMISSION_ACCESS {
    READ = 'READ',
    WRITE = 'WRITE',
    ADMIN = 'ADMIN',

    DEV_USER = 'DEV_USER'
}

export enum PERMISSIONS {
    // SYS_ADMIN checks whether the user type is SUPER_ADMIN or not
    DEV_USER = 'DEV_USER',

    ADMIN_USER_TABLE = 'ADMIN_USER_TABLE',
    GLOBAL_ROLES = 'GLOBAL_ROLES',
    CUSTOMER_USER_TABLE = 'CUSTOMER_USER_TABLE',
    COLLECTION_LOGS = 'COLLECTION_LOGS',
    ADD_COLLECTION = 'ADD_COLLECTION',
    RECEIPT_LOGS = 'RECEIPT_LOGS',
    EXCEL_UPLOAD = 'EXCEL_UPLOAD',
    EXCEL_DOWNLOAD = 'EXCEL_DOWNLOAD',
    MILESTONES = 'MILESTONES',
    FLAT = 'FLAT',
    DEMAND_LOGS = 'DEMAND_LOGS',
    PROJECT_CONFIGURATION = 'PROJECT_CONFIGURATION',
    FLAT_CANCELLATION = 'FLAT_CANCELLATION',
    COST_SHEET = 'COST_SHEET',
    FLAT_COST_SHEET = 'FLAT_COST_SHEET',
    GLOBAL_CONFIGURATION = 'GLOBAL_CONFIGURATION',
    DEMAND_LETTER_REPORTS = 'DEMAND_LETTER_REPORTS',
    RECEIPTS_LOG_REPORTS = 'RECEIPTS_LOG_REPORTS',
    TELE_CALLING = 'TELE_CALLING',
    NOTIFICATIONS = 'NOTIFICATIONS',
    WHATSAPP_CHAT = 'WHATSAPP_CHAT',
    BANKS_KYC = 'BANKS_KYC',
    EMAIL = 'EMAIL',
    FLAT_SWAP = 'FLAT_SWAP',
    FLAT_TRANSFER = 'FLAT_TRANSFER',
    AUDIT_LOGS = 'AUDIT_LOGS',
    APPROVE_RECEIPT_LOG = 'APPROVE_RECEIPT_LOG',
    COST_CONFIGURATION = 'COST_CONFIGURATION',
    TRANSFER_RECEIPT = 'TRANSFER_RECEIPT',
    FLAT_EXECUTIVE_ASSIGNMENT = 'FLAT_EXECUTIVE_ASSIGNMENT',
    AGREEMENT_FOR_SALE = 'AGREEMENT_FOR_SALE',
    AGREEMENT_FOR_SALE_STAMP_FRANKING_DOWNLOAD = 'AGREEMENT_FOR_SALE_STAMP_FRANKING_DOWNLOAD',
    BULK_COMMUNICATION = 'BULK_COMMUNICATION',
    ACTIVITY = 'ACTIVITY',
    MISSING_CALL_RECORDS = 'MISSING_CALL_RECORDS',
    HANDOVER = 'HANDOVER',
    TRENDS = 'TRENDS',
    OVERVIEW_DASHBOARD = 'OVERVIEW_DASHBOARD',
    CREDIT_REPORT = ' CREDIT_REPORT',

    MIS_SHEET = 'MIS_SHEET',
    MIS_PERSONAL_DETAILS = 'MIS_PERSONAL_DETAILS',
    MIS_CITIZENSHIP = 'MIS_CITIZENSHIP',
    MIS_COMMUNICATION = 'MIS_COMMUNICATION',
    MIS_KYC = 'MIS_KYC',
    MIS_RESIDENCY_DETAILS = 'MIS_RESIDENCY_DETAILS',
    MIS_OCCUPATION_DETAILS = 'MIS_OCCUPATION_DETAILS',
    MIS_OBLIGATIONS = 'MIS_OBLIGATIONS',
    MIS_FLAT_DETAILS = 'MIS_FLAT_DETAILS',
    MIS_COST_SHEET = 'MIS_COST_SHEET',
    MIS_BANK_DETAILS = 'MIS_BANK_DETAILS',
    MIS_DOCUMENTS = 'MIS_DOCUMENTS',
    MIS_FOIR = 'MIS_FOIR',
    MIS_STAGE_DETAILS = 'MIS_STAGE_DETAILS',
    MIS_POC_DETAILS = 'MIS_POC_DETAILS',

    APPLICANT_CONTACT_NUMBER_VIEW = 'APPLICANT_CONTACT_NUMBER_VIEW',
    APPLICANT_CONTACT_NUMBER_EDIT = 'APPLICANT_CONTACT_NUMBER_EDIT',
    APPLICANT_EMAIL_VIEW = 'APPLICANT_EMAIL_VIEW',
    APPLICANT_EMAIL_EDIT = 'APPLICANT_EMAIL_EDIT',

    // Flat-file view selectors (Sales = pre booking-form signed; CRM = signed onwards).
    FLAT_LIST_VIEW_SALES = 'FLAT_LIST_VIEW_SALES',
    FLAT_LIST_VIEW_CRM = 'FLAT_LIST_VIEW_CRM',
    FLAT_LIST_VIEW_MANAGER = 'FLAT_LIST_VIEW_MANAGER'
}
